import { Box } from '@energiebespaarders/symbols';
import { Heading } from '@energiebespaarders/symbols/helpers';
import { isHeading } from 'datocms-structured-text-utils';
import { renderRule, StructuredText } from 'react-datocms';
import styled from 'styled-components';
import { BlockRenderer } from './BlockRenderer';
import InlineRecordRenderer from './InlineRecordRenderer';
import type { BlockRendererOverrides, CMSBlock } from './BlockRenderer';
import type { StructuredTextGraphQlResponse } from 'react-datocms';

export type CMSStructuredTextData = {
  readonly __typename: string;
  readonly blocks: ReadonlyArray<CMSBlock>;
  readonly links: ReadonlyArray<string>;
  readonly value: any;
};

interface Props {
  data: CMSStructuredTextData | null;
  overrides?: BlockRendererOverrides;
}

const StyledHeading = styled(Heading)`
  margin-bottom: 0em;
  margin-top: 1.5em;
`;

const TypedStructuredText: React.FC<Props> = ({ data, overrides }) => {
  return (
    <Box className="dato-cms">
      <StructuredText
        data={data as unknown as StructuredTextGraphQlResponse}
        renderBlock={b => (
          <BlockRenderer block={b.record as unknown as CMSBlock} overrides={overrides} />
        )}
        renderInlineRecord={InlineRecordRenderer}
        customNodeRules={[
          renderRule(isHeading, ({ node, children, key }) => {
            const heading = `h${node.level}`;
            return (
              <StyledHeading heading={heading} fontSize={Math.min(5, node.level + 1)} key={key}>
                {children}
              </StyledHeading>
            );
          }),
        ]}
      />
    </Box>
  );
};

export default TypedStructuredText;
